import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CustomerFieldDTO } from 'app/public/model/CustomerFieldDto';
import { Roulette } from 'app/public/model/roulette.model';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CustomerFields } from 'app/shared/model/enums';

@Component({
  selector: 'app-field-dialog',
  templateUrl: './field-dialog.component.html',
  styleUrl: './field-dialog.component.scss'
})
export class FieldDialogComponent implements OnInit {

  constructor(private localizationService: LocalizationService, private cdr: ChangeDetectorRef) {
    //this.localizationService.Translate
  }
  ngOnInit(): void {
    this.customerFields = this.roulette.AdditionalCustomerFields;
    if (this.customerFields) {
      this.customerFields.forEach(cf => {
        if (cf.Options != null)
          cf.ArrayOptions = cf.Options.split(",")
      })
    }
    this.fieldTypes = this.enumToArray(CustomerFields, "CustomerFields")
  }
  @Input()
  roulette: Roulette;
  @Input()
  form: NgForm;
  @Output() fieldsUpdated = new EventEmitter<CustomerFieldDTO[]>();
  emitFields() {
    this.fieldsUpdated.emit(this.customerFields);
  }
  customerFields: CustomerFieldDTO[]
  fieldTypes: { label: string; value: number }[] = [];
  customerFieldTypes = CustomerFields;

  enumToArray(enumObj: any, translationPrefix: string): { value: number, label: string }[] {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        value: enumObj[key],
        label: this.localizationService.Translate(`ENUMS.${translationPrefix}.${key}`)
      }));
  }
  addField() {
    if (!this.customerFields || this.customerFields.length === 0) {
      this.customerFields = [];
    }
    const newField: CustomerFieldDTO = {
      FieldId: null,
      FieldName: '',
      FieldType: this.fieldTypes[0]?.value ?? 0,
      Required: false,
      // FieldNameInEnglish: ''
    };
    this.customerFields.push(newField);
  }
  update() {
    this.customerFields.forEach(cf => {
      if (cf.ArrayOptions != null)
        cf.Options = cf.ArrayOptions.join(",");
      // if (cf.ArrayOptionsInEnglish != null)
      //   cf.OptionsInEnglish = cf.ArrayOptionsInEnglish.join(",")
    })
    this.emitFields()
  }
  deleteField(field: CustomerFieldDTO) {
    const index = this.customerFields.indexOf(field);
    if (index !== -1) {
      this.customerFields = [
        ...this.customerFields.slice(0, index),
        ...this.customerFields.slice(index + 1)
      ];
    }
    this.cdr.markForCheck()
  }
  getPreviewOptions(field: CustomerFieldDTO): { label: string; value: string }[] {
    if (!field.ArrayOptions || !field.ArrayOptionsInEnglish) {
      return [];
    }

    return field.ArrayOptions.map((opt, index) => ({
      label: opt + ' / ' + (field.ArrayOptions[index] || ''),
      value: opt
    }));
  }
  getFieldType(fieldType: CustomerFields): string {
    const fieldTypeMap = {
      [CustomerFields.text]: 'text',
      [CustomerFields.boolean]: 'checkbox',
      [CustomerFields.date]: 'date',
      [CustomerFields.number]: 'number',
      // [CustomerFields.list]: '', // or 'textarea'
    };

    return fieldTypeMap[fieldType] || 'text'; // Default to 'text' if no match
  }
}
